import { Dd } from './Dropdown.js';
import { defaultCodeOptions } from '../lib/caseManagementNote.js';

/**
 * ehr#725 (CASE_MANAGEMENT_NOTE_10-30-V9, 14 A): Note settings > Practice note settings on a case
 * management note, for admins and managers (they save the practice's billing codes): the one
 * "Default billing code" row. Saved with the window's Save (PUT /practice/clinical serviceCodes);
 * the open draft takes the new default unless its author picked a code by hand.
 */
export function DefaultCodeRow({
  value,
  onChange,
}: {
  /** The code ('' is No default, billed by hand). */
  value: string;
  onChange: (code: string) => void;
}) {
  return (
    <div className="pn-ns-field" data-test="svc-codes" style={{ maxWidth: 380 }}>
      <span>Default billing code</span>
      <Dd
        value={value}
        onChange={onChange}
        options={defaultCodeOptions()}
        searchable={false}
        ariaLabel="Default billing code"
        floating
      />
    </div>
  );
}
